import React, { useState } from 'react';
import Button from 'components/ui/Button';
import Input from 'components/ui/Input';
import Icon from 'components/AppIcon';

const AddProductModal = ({ onClose, onSubmit, clients }) => {
  const [formData, setFormData] = useState({
    title: '',
    product_code: '',
    client: '',
    description: '',
    image: '',
    status: 'active'
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
  const { name, value } = e.target;  // Use 'name' instead of 'title'
  setFormData(prev => ({
    ...prev,
    [name]: value   // Dynamically update the field based on the input's name attribute
  }));

  // Clear error when user starts typing
  if (errors[name]) {
    setErrors(prev => ({
      ...prev,
      [name]: ''  // Clear the error for the specific field
    }));
  }
};
  const handleFileChange = (e) => {
    setFormData(prev => ({
      ...prev,
      image: e.target.files[0]
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.title.trim()) {
      newErrors.title = 'Product title is required';
    }

    if (!formData.product_code.trim()) {
      newErrors.product_code = 'product_code is required';
    }

    if (!formData.client.trim()) {
      newErrors.client = 'Client is required';
    }

   

   

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    
    if (validateForm()) {
      try {
            setLoading(true);
            // Create FormData object to send all the data, including file upload
            const formDataWithLogo = new FormData();
            formDataWithLogo.append('title', formData.title);
            formDataWithLogo.append('client_id', formData.client);
            formDataWithLogo.append('product_code', formData.product_code);
            formDataWithLogo.append('description', formData.description);
            const token = localStorage.getItem('token')

            // Append logo if available
            if (formData.image) {
                formDataWithLogo.append('image', formData.image);
            }

            // Send the form data to the backend (API)
            const response = await fetch(import.meta.env.VITE_APP_ADMINURL+'/api/product-data', {
                method: 'POST',
                headers:{
                  'Authorization': `Bearer ${token}`
                },
                body: formDataWithLogo,  // Send FormData with the logo file
            });

            if (response.ok) {
                const data = await response.json();
                // console.log('User added successfully:', data);
                onSubmit(data);
            } else {
                const error = await response.json();
                console.error('Error adding user:', error);
            }
        } catch (error) {
            console.error('Something went wrong:', error);
        } finally {
            setLoading(false);
        }
      // onSubmit({
      //   ...formData,
      // });
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 ">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h2 className="text-xl font-semibold text-text-primary">Add New Product</h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <Icon name="X" size={20} color="#6b7280" />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="p-6 space-y-4 max-h-[75vh] overflow-y-auto">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Product Name *
            </label>
            <Input
              type="text"
              name="title"
              value={formData.title}
              onChange={handleInputChange}
              placeholder="Enter product title"
              className={errors.title ? 'border-red-500' : ''}
            />
            {errors.name && (
              <p className="mt-1 text-sm text-red-600">{errors.title}</p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Product Code *
            </label>
            <Input
              type="text"
              name="product_code"
              value={formData.product_code}
              onChange={handleInputChange}
              placeholder="Enter Product Code"
              className={errors.product_code ? 'border-red-500' : ''}
            />
            {errors.product_code && (
              <p className="mt-1 text-sm text-red-600">{errors.product_code}</p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Client *
            </label>
            <select
              name="client"
              value={formData.client}
              onChange={handleInputChange}
              className={`w-full px-3 py-2 border rounded-md focus:ring-2 focus:ring-ring focus:border-transparent ${
                errors.client ? 'border-red-500' : 'border-input'
              }`}
            >
              <option value="">Select client</option>
              {Array.isArray(clients) && clients.length > 0 ? (
                clients.map(client => (
                  <option key={client.id} value={client.id}>
                    {client.company_name}
                  </option>
                ))
              ) : (
                <option disabled>No clients available</option>
              )}
            </select>
            {errors.client && (
              <p className="mt-1 text-sm text-red-600">{errors.client}</p>
            )}
          </div>

          
          {/* Additional Options */}
          <div>
            <h3 className="text-lg font-medium text-text-primary mb-4">Product Image</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              <input
                  type="file"
                  onChange={handleFileChange}
                  className="w-full px-3 py-2 border rounded-lg"
                />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Description *
            </label>
            <textarea
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              rows="3"
              placeholder="Enter product description"
              className="w-full px-3 py-2 border border-input rounded-md focus:ring-2 focus:ring-ring focus:border-transparent"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Status
            </label>
            <select
              name="status"
              value={formData.status}
              onChange={handleInputChange}
              className="w-full px-3 py-2 border border-input rounded-md focus:ring-2 focus:ring-ring focus:border-transparent"
            >
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>

          {/* Actions */}
          <div className="flex justify-end space-x-3 pt-4">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              disabled={loading}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="primary"
              className='text-white'
              loading={loading}
            >
             <span>Add Product</span>
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddProductModal;
